import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'

export type GetBillRateShiftsRequest = {
  billRateId: number
  page: number
  pageSize: number
}

export type BillRateShift = {
  id: number
  startsAt: string
  endsAt: string
  workersAccepted: number
  workersNeeded: number
  invoiced: boolean
  timezone: string | null
}

export type GetBillRateShiftsResponse = {
  items: BillRateShift[]
  totalRows: number
  totalPages: number
  currentPage: number
  pageSize: number
}

export const getBillRateShifts = async (
  request: GetBillRateShiftsRequest
): Promise<GetBillRateShiftsResponse> => {
  const response = await api.get<GetBillRateShiftsResponse>(
    `/admin/bill_rate/${request.billRateId}/shifts`,
    {
      params: {
        page: request.page,
        pageSize: request.pageSize,
      },
      paramsSerializer: queryParamSerializer,
    }
  )
  return response.data
}
